

import React, { useEffect, useState } from 'react'
import IframeView from './paywall-views/iframe-view';
import SuccessView from './paywall-views/success-view';
import FailureView from './paywall-views/failure-view';
import CancelView from './paywall-views/cancel-view';
import LoadingView from './paywall-views/loading-view';
import { PaywallTranslations } from './paywall-comp';
import { Typography } from '../../../react/components/typography/typography';
import { CampaignDetails } from './goat-464-test/paywall-comp';

export type PaymentStatus = "pending" | "success" | "failure" | "cancel" | "unknown" | "done";

export const PaywallInlinePayment = ({
  onSuccessfulPayment,
  onPaymentPageLoaded,
  onCloseModal,
  modalInitialState,
  translations,
  campaign,
}: {
  onSuccessfulPayment: () => void
  onPaymentPageLoaded: () => void
  onCloseModal: () => void
  modalInitialState?: PaymentStatus;
  translations: PaywallTranslations;
  campaign: CampaignDetails;
}) => {
  const [state, setState] = useState<PaymentStatus>(modalInitialState ? modalInitialState : "pending");

  const messageHandler = (event) => {
    const data = event.data;

    if (data.paymentStatus) {
      console.log(data)
      if (data.dataLayerObject && data.dataLayerObject.event != "purchase") {
        const o = data.dataLayerObject;
        window.dataLayer.push(o)
      }

      if (data.paymentStatus == 'success') {
        setState('success')
        onSuccessfulPayment()
      } else if (data.paymentStatus == 'failure' || data.paymentStatus == 'unknown') {
        setState('failure')
      } else if (data.paymentStatus == 'cancel') {
        setState('cancel');
      }
    }
  }

  const retryPayment = () => {
    setState('pending')
  }

  useEffect(() => {
    window.addEventListener("message", messageHandler);
    return () => {
      window.removeEventListener("message", messageHandler)
    }
  }, [])

  const close = () => {
    setState('done')
    onCloseModal()
  }

  if (state == "done") return null;

  return (
    <div style={{maxWidth: '462px', width: '100%', margin: '0 auto', padding: '32px 0'}}>
      {(() => {

        if (!campaign) {
          return <LoadingView />
        }

        switch (state) {
          case 'pending':
            return <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
              <div style={{padding: '0 16px'}}>
                <Typography
                  element='div'
                  textSize='sys-display-small'
                  themeColor='text-ink-main'
                  style={{textAlign: 'center'}}
                >
                  {translations['lokalise.payment.payment_details']}
                </Typography>
                <Typography
                  element='div'
                  textSize='sys-title-medium'
                  themeColor='text-ink-offset'
                  style={{textAlign: 'center', marginTop: '8px', marginBottom: '15px'}}
                >
                  {translations['lokalise.catalog.article_paywall.payments_only_accepted_from']}
                </Typography>
              </div>

              <IframeView url={campaign?.link + "&in_modal=yes"} onLoaded={() => {
                setInterval(() => {
                  var iframe = document.getElementById('paywall-payment-iframe') as any;
                  if (iframe && iframe.contentWindow && iframe.contentWindow.document.body && iframe.contentWindow.document.body.scrollHeight) {
                    iframe.height = iframe.contentWindow.document.body.scrollHeight + 70 + "px";
                  }
                }, 100)

                onPaymentPageLoaded()
              }} />
            </div>

          case 'success':
            return <SuccessView close={close} translations={translations} />;

          case 'failure':
            return <FailureView retryPayment={retryPayment} translations={translations} />;

          case 'cancel':
            return <CancelView retryPayment={retryPayment} translations={translations} />;

          default:
            break;
        }
      })()}
    </div>
  )
}

